function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_3"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1"
}, /*#__PURE__*/React.createElement("path", {
  className: "svg-fill-pink",
  d: "M14.64,12c0,1.46-1.18,2.64-2.64,2.64S9.36,13.46,9.36,12S10.54,9.36,12,9.36S14.64,10.54,14.64,12z  M21.97,13h-2.56c-0.45,3.33-3.08,5.96-6.41,6.41v2.56h-2v-2.56C7.67,18.96,5.04,16.33,4.59,13H2.02v-2h2.56 C5.04,7.67,7.67,5.04,11,4.59V2.02h2v2.56c3.33,0.45,5.96,3.08,6.41,6.41h2.56V13z M17.49,12c0-3.03-2.46-5.49-5.49-5.49 c-3.02,0-5.49,2.46-5.49,5.49c0,3.02,2.46,5.49,5.49,5.49C15.03,17.49,17.49,15.02,17.49,12z"
}));

var SvgIconCoordinate = function SvgIconCoordinate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCoordinate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_coordinate.1f8eda24.svg";
export { ForwardRef as ReactComponent };